exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3QXj-5jl4LTmBPmU9SlcTl{height:32px}html[dir] ._3QXj-5jl4LTmBPmU9SlcTl{border-radius:2px}html[dir=ltr] ._3QXj-5jl4LTmBPmU9SlcTl{margin:0 26px 0 8px}html[dir=rtl] ._3QXj-5jl4LTmBPmU9SlcTl{margin:0 8px 0 26px}", ""]);
// Exports
exports.locals = {
	"sendButton": "_3QXj-5jl4LTmBPmU9SlcTl"
};